<template>
    <div class="module-wrapper" :class="[theme]">
        <div v-if="theme === 'broker'" class="wrap">
            <p v-if="title" :class="[theme, 'module-wrapper-title']">
                {{ title }}
            </p>
            <span v-if="theme === 'broker'" class="line"></span>
        </div>
        <template v-else>
            <p v-if="title" :class="[theme, 'module-wrapper-title']">
                {{ title }}
            </p>
        </template>
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: ''
        },
        theme: {
            //  display style
            type: String
        }
    }
};
</script>

<style lang="scss">
@import '../theme/media.scss';
@import '@/theme/mixin.scss';

.module-wrapper {
    &.broker {
        .wrap {
            display: flex;
            flex-direction: row;
            margin-bottom: 10px;
            align-items: center;
            .line {
                flex: 1;
                height: 1px;
                background: #dadada;
                transform: scaleY(0.5);
            }
        }
    }
    .module-wrapper-title {
        margin-bottom: 10px;
        position: relative;
        font-size: 20px;
        line-height: 24px;
        color: #4a4a60;
        font-family: var(--font-black);

        &.standard {
            color: #000000;
            font-family: var(--font-title);
            font-size: 18px;
            padding-left: 16px;
            &:before {
                position: absolute;
                left: 0;
                top: 0;
                content: '';
                width: 4px;
                height: 100%;
                @include color-theme('background-color');
            }
        }
        &.template4 {
            color: #4a4a60;
            font-family: var(--font-bold);
            font-size: 20px;
        }
        &.template2 {
            font-size: 18px;
            font-family: var(--font-bold);
            color: #191919;
            line-height: 22px;
        }
        &.broker {
            color: #191919;
            font-family: var(--font-bold);
            font-size: 16px;
            padding-right: 10px;
            position: relative;
            margin-bottom: 0;
        }
    }
}
</style>
